import { memo, useState } from 'react'
import './layoutFooter.less'

interface propTypes {
  lang: string
}

interface SetEmail {
  (email: string): void
}

function LayoutFooter (props: propTypes) {
  const { lang } = props
  const [email, setEmail]: [string, SetEmail] = useState<string>('')

  const goRegister = (): void => {
    if (!email) return
    window.location.href = `/en/register/?email=${email}`
  }

  return (
    <footer className='layout-footer' id='contact_us'>
      <div className={`home-free-use-wrap ${lang}`}>
        <div className='home-free-use'>
          <h3 className='home_freeUse_title'>{__('Start your dropshipping business now')}</h3>
          <div className='input-wrap'>
            <input
              className='home_freeUse_input'
              onChange={e => setEmail(e.target.value)}
              value={email}
              type='email'
              placeholder={__('Enter your email address')}
              onKeyDown={e => {
                e.keyCode === 13 && goRegister()
              }}
            />
            <button onClick={goRegister} className='goRegister'>{__('Get Started')}</button>
          </div>
        </div>
      </div>
      <div className='bottom-box'>
        <div className='bottom-email'>
          <div className='contactUs'>
            <p className='contactUs_title'>{__('Contact Us')}</p>
            <a className='contactUs_link' href='mailto:support@buckydrop.com'>support@buckydrop.com</a>
          </div>
          <div className='email-address'>
            <p>
              {__('Tel: +86 755 8829 4480 (General Enquiries: Monday to Sunday 9:00 to 18:00 Beijing Time)')}
            </p>
            <p>
              {__('Address: Shenzhen Service Center: AB-5B, F2.6 Tianzhan Building, Tian\'an Cyber Park, Futian District, Shenzhen')}
            </p>
            <p>
              {__('Hong Kong Office: Flat B, 15/F, Win Sun Factory Building, 2 San Hop Lane Tuen Mun, New Territories, Hong Kong')}
            </p>
            <p>
              {__('Shenzhen R&D Center & Huizhou Logistics Center')}
            </p>
            <p>
              {__('Service Location: United States, Canada, Australia, United Kingdom, Germany, New Zealand, Singapore, Italy, Spain, Brazil, Poland, United Arab Emirates and so on')}
            </p>
          </div>
          <div className='email-intro'>
            <p>{__('Unsolved problems? Talk to the boss! Email is guaranteed to be replied within 2 working days',)}</p>
            <p>{__('(If not, please check your junk mail).')}</p>
          </div>
          <p className='email_ceo_contact'>{__('Contact CEO')}</p>
          <a className='email-ceo' href='mailto:ceo@buckydrop.com'>
            CEO@buckydrop.com
          </a>
        </div>
        <div className='bottom-logo'>
          <div className='links-box follow-us'>
            <p className='follow_us_title'>{__('Follow us')}</p>
            <div className='follow-share'>
              <ul className='footer-sns'>
                <li>
                  <a href='https://www.youtube.com/channel/UC4RwWcE_Nz3_SFey6tbGOLA' target='_blank' />
                </li>
                <li>
                  <a href='https://www.facebook.com/BuckyDrop.Official/' target='_blank' />
                </li>
                <li>
                  <a href='https://www.instagram.com/buckydrop_official/' target='_blank' />
                </li>
                <li>
                  <a href='https://twitter.com/BuckyDrop' target='_blank' />
                </li>
              </ul>
            </div>
          </div>
          {
            <div className='links-box forums'>
              <p className='follow_us_title'>{__('Forums')}</p>
              <div className='follow-share'>
                <ul className='footer-sns'>
                  <li>
                    <a href='http://bbs.buckydrop.com' target='_blank' />
                  </li>
                </ul>
              </div>
            </div>
          }
        </div>
      </div>
      <div className='copyright_box'>
        <p className='copyright_box_linkWrapper'>
          <a className='copyright_link copyright_box_linkWrapper_link' href={`/${lang}/about_us`} target='_blank'>{__('About Us')}</a>
          <span className='link_border' />
          <a className='copyright_link copyright_box_linkWrapper_link' href={`/${lang}/contact_us`} target='_blank'>{__('Contact Us')}</a>
          <span className='link_border' />
          <a className='copyright_link copyright_box_linkWrapper_link' href='/en/agreement' target='_blank'>{__('Service Agreement')}</a>
          <span className='link_border' />
          <a className='copyright_link copyright_box_linkWrapper_link' href='/en/privacy' target='_blank'>{__('Privacy Policy')}</a>
          <span className='link_border' />
          <a className='copyright_link copyright_box_linkWrapper_link' href={`/${lang}/help`} target='_blank'>{__('Help Center')}</a>
        </p>
        <p className='copyright_box_desc'>
          <span className='copyright_box_desc_left'>
            &copy; 2012-{new Date().getFullYear()}&nbsp;
            {__('BuckyDrop.com.All Rights Reserved.')}
          </span>
          <a className='copyright_link' href='https://beian.miit.gov.cn/#/Integrated/recordQuery' target='_blank' >
              粤ICP备19083436号
          </a>
          <span className='copyright_box_desc_border' />
          <span className='copyright_box_desc_company'>{__('Shenzhen Qianhai STARIT Cross Border Ecommerce Limited')}</span>
        </p>
      </div>
    </footer>
  )
}

export default memo(LayoutFooter)
